import { createSelector } from 'reselect';

const selectToastsState = (state) => state.toastsReducer;

export const getToastProps = () => createSelector(selectToastsState, (state) => state.toastData);

